<template lang="pug">
.promo--card-container
  Loader(v-if='renderLoader', absolute)
  PageError(v-else-if='pageError.status', :type='pageError.type')
  Card(
    v-else,
    v-for='promo in promoList',
    :promo='promo',
    :key='promo.id',
    @click='clickPromo(promo)',
    v-view='(event) => viewHandler(event,promo)'
  ).promo--card
    BannerImage.mb-3(rounded, :src='promo.properties.url_image')
    Title.mb-1 {{ promo.properties.title }}
    .promo--card__image
      Description(v-html='promo.properties.detail_summary')
    Note.mb-2.mt-2(v-if='promo.properties.date_visibility') Promo berlaku sampai dengan {{ formattedDate(promo.properties.end_date) }}
    Alert(
      v-if='promo.properties.highlight',
      :message='promo.properties.highlight',
      bgColor='#E1FFF1',
      textColor='#00A460'
    )
</template>

<script>
import { mapGetters } from 'vuex';
import { Card, Title, Note, Alert, Description, BannerImage, PageError, Loader } from '@ovo/ravier-vue';
import JSBridge  from '@/helpers/jsbridge';

export default {
  name: 'PromoCardContainer',
  components: {
    Loader,
    Card,
    Title,
    Loader,
    PageError,
    Alert,
    Note,
    Description,
    BannerImage,
  },
  data() {
    return {
      promoPositions: {},
    };
  },
  computed: {
    ...mapGetters({
      activeCategory: 'getActiveCategory',
      renderLoader: 'getRenderLoader',
      pageError: 'getPageError',
      promoRecommendations: 'getPromoRecommendations',
    }),
    promoList() {
      let promos = [];
      this.promoRecommendations.forEach(promo => {
        if (promo.id === this.activeCategory) {
          promos = promo.components;
          promo.components.forEach(component => {
            this.promoPositions[component.id] = {
              lastPosition: 0,
              currentPosition: 0,
            };
          });
        }
      });
      return promos;
    },
    promoType() {
      return this.$route?.query?.type || '';
    },
  },
  methods: {
    formattedDate(date_input) {
      const date = new Date(date_input);
      return `${date.getDate()} ${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
    },
    clickPromo(promo) {
      const jsBridge = new JSBridge();
      const promoEvent = {
        Promo_ID: promo.id,
        Promo_Name: promo.properties.title,
        Banner_Deeplink: promo.properties.url_image,
        Tab_Name: this.promoType,
      };
      jsBridge.leanplumWebviewTracker('event/promo_page/click_promo', {
        Trigger: 'Banner Click',
        TriggerValue: 'Click Banner',
        Product: promo.id,
        Page: 'Promo Page',
        ...promoEvent,
        Description: `Banner Click - Click Banner - ${promo.id} - Promo Page`,
      });
      this.$router.push(`detail?id=${promo.id}&tab_referrer=${this.promoType}&referrer=impression/banner_promo_page`);
    },
    viewHandler(event, promo) {
      this.promoPositions[promo.id].lastPosition = this.promoPositions[promo.id].currentPosition;
      this.promoPositions[promo.id].currentPosition = event.percentInView;
      // If promo last position is out of viewport and current position is in viewport 
      if (this.promoPositions[promo.id].lastPosition === 0 && this.promoPositions[promo.id].currentPosition > 0) {
        const jsBridge = new JSBridge();
        const promoEvent = {
          Banner_ID: promo.id,
          Banner_Name: promo.properties.title,
          Banner_Deeplink: promo.properties.url_target,
          Promo_ID: promo.id,
          Promo_Name: promo.properties.title,
          Tab_Name: this.promoType,
        };
        jsBridge.leanplumWebviewTracker('impression/promo_page', {
          Trigger: 'Page Load',
          TriggerValue: 'See Promo Page',
          Product: 'Promo Page',
          Page: 'Promo Page',
          ...promoEvent,
          Description: 'Page Load - See Promo Page - Promo Page - Promo Page',
        });
      }
    },
  },
};
</script>
